// extracted by mini-css-extract-plugin
export default {"w250":"styles_w250__1S2iz","mw250":"styles_mw250__GMwl1"};